export default "__VITE_ASSET__B51ul7yt__"